<input
  #input
  matInput
  type="text"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [(ngModel)]="value"
  (keydown.enter)="$event.preventDefault();"
/>
